export default __webpack_public_path__ + "static/roll-off-dumpsters-4a1927b4a27e155ab4f02bb4273132c6.jpg";